import { faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import { colors } from '../constants';

const Wrapper = styled.div`
  margin-top: 128px;
`;
const Link = styled.a`
  display: inline-block;
  color: white;
  background: ${colors.primary};
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 16px;
  padding: 16px 32px;
  font-size: 1.2rem;
  max-width: 440px;
  display: flex;
  align-items: center;
  &:hover,
  &:focus {
    background: ${colors.primaryDark};
    text-decoration: none;
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-right: 16px;
`;

const FeedbackLink = () => (
  <Wrapper id="feedback-link">
    <Link href="/anna-palautetta/">
      <Icon icon={faComment} size="lg" />
      Kerro palvelutoiveesi tai jätä palautetta hakemistosta
    </Link>
  </Wrapper>
);

export default FeedbackLink;
